module.exports = __webpack_public_path__ + "img/left-circle.934dc398.svg";